"use client";

import { useMergeRefs } from "@floating-ui/react";
import React, { isValidElement, cloneElement } from "react";

import { usePopoverContext } from "./PopoverContext";

type IProps = React.HTMLProps<HTMLElement>;

export const PopoverTrigger: React.FC<IProps> = ({
  children,
  ref: propRef,
  ...props
}) => {
  const { refs, getReferenceProps, open } = usePopoverContext();
  const childrenRef = (children as unknown as { ref?: React.Ref<HTMLElement> })
    .ref;
  const ref = useMergeRefs([refs.setReference, propRef, childrenRef]);

  if (!isValidElement(children)) {
    // eslint-disable-next-line no-console
    console.error("PopoverTrigger must have a valid child element");
    return null;
  }

  return cloneElement(
    children,
    getReferenceProps({
      ref,
      ...props,
      ...(children.props as Record<string, unknown>),
      "data-state": open ? "open" : "closed",
    } as Record<string, unknown>)
  );
};
